import { Article } from '../types';
import { ArticleRepository } from '../utils/repository';

class ArticlesSearch extends ArticleRepository<Article> {
  override getMany(query: { tag: Ref<string>; category: Ref<string>; query: Ref<string> }) {
    return this._getMany({
      url: `/search`,
      query: { ...query, limit: 40 },
    });
  }
}

export const articlesSearchRepository = new ArticlesSearch();
